import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ADRService {

    constructor(private httpClient: HttpClient) { }

    searchADR(searchInput: string) {
        return this.httpClient.post(`${environment.apiUrl}/adr/search`, { searchInput });
    }

    AdrRuleCheckerFunc(parms: AdrTransportInput) {
        return this.httpClient.post<StupidAdrRuleResultFix>(`${environment.apiUrl}/adr/adrrulechecker`, parms);
    }

}
export interface AdrTransportInput {

    UNNo: number
    Amount: number; // in kg or liters
    IsMixLoad: boolean; // sould always defult to true
    ADRVersion: number; // the year to use
    id:string;
}
export interface StupidAdrRuleResultFix {
    item: AdrRuleResult;
}
export interface AdrRuleResult {
    isAllowed: boolean;
    reason: string;
    points: number;
}


